// RECONSTRUCTED STUB (data loss recovery)
// Original file was untracked and accidentally deleted during W1-A4-UI scope-violation cleanup.
// Signature inferred from grep across the codebase: translateText(t, key, fallback, options?)
// — returns the i18n translation when present, else the fallback, else the key.

export type TranslateTextOptions = Record<string, unknown>

export function translateText(
  t: ((key: string, options?: TranslateTextOptions) => string) | undefined,
  key: string,
  fallback?: string,
  options?: TranslateTextOptions
): string {
  if (typeof t === 'function') {
    try {
      const result = t(key, options)
      if (typeof result === 'string' && result !== key) {
        return result
      }
    } catch {
      // fall through to fallback
    }
  }
  const raw = fallback ?? key
  if (!options) {
    return raw
  }

  return raw.replace(/\{\{(\w+)\}\}/g, (_, placeholder: string) =>
    options[placeholder] !== undefined ? String(options[placeholder]) : '',
  )
}
